<template>
  <div class="pa-2">
    <v-row>
      <v-col>
        <div class="d-flex">
          <v-btn @click="createClientDialog = true" v-if="buttonShow('create')" class="secondary">
            Create new
          </v-btn>
          <!-- Reload button -->
          <v-btn class="ml-2 pt-2 secondary--text" color="secondary" small icon @click.stop="paginate(1)">
            <i class="fa fa-repeat secondary--text"></i>
          </v-btn>
          <v-text-field
            v-model="filter"
            append-icon="search"
            label="Search an Existing Client"
            single-line
            hide-details
            solo
            dense
            class="pl-3"
            style="max-width:350px"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card-title class="pl-0 pr-0">
          <v-btn
            small
            color="warning"
            :disabled="!selectedClients || selectedClients.length === 0"
            @click="openClientGroupModal()"
            v-if="selectedClients"
          >Add to Group ({{selectedClients.length}})</v-btn>
          <!-- <v-spacer></v-spacer> -->
        </v-card-title>
        <v-data-table
          striped
          bordered
          hover
          responsive
          :headers="fields"
          :items="items"
          :search="filter"
          class="client-nested-table client-root-table elevation-1"
          show-select
          show-expand
          :expanded.sync="expanded"
          :key="dataTableKey"
          item-key="id"
          @toggle-select-all="selectAllClients"
          :single-select="false"
          v-model="selectedClients"
        >
          <!-- <template v-slot:[`group.header`]="{items, isOpen, toggle}">
            <th colspan="8" v-if="items[0].groupName !== 'Z-NoGroup'">
              <v-icon @click="toggle"
                >{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
              {{ items[0].groupName }}
            </th>
          </template> -->
          <template v-slot:[`item.data-table-expand`]="{item, expand, isExpanded}">
            <span>
              <v-icon @click="expand(false)" v-if="isExpanded">mdi-chevron-up</v-icon>
              <v-icon @click="expand(true)" v-else>mdi-chevron-down</v-icon>
            </span>
          </template>
          <template v-slot:[`item.data-table-select`]="{item}">
            <v-checkbox
              v-model="selectedClients"
              label=""
              :value="item"
              v-if="!item.isGroup"
              color="grey darken-2"
            ></v-checkbox>
            <v-icon v-else>mdi-domain</v-icon>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <div v-if="item.isGroup && item.groupEdit">
              <v-text-field
                class="input-field mt-3"
                v-model="item.name"
                dense
                outlined
                v-on="on"
                placeholder="Campaign Name"
              ></v-text-field>
            </div>
            <div class="item-edit" v-else>
              <td class="text-center">{{item.name}}</td>
            </div>
          </template>
          <template v-slot:[`item.IO`]="{ item }">
            <div>
              <td class="text-center">{{item.IO}}</td>
            </div>
          </template>
          <template v-slot:[`item.dealCode`]="{ item }">
            <div>
              <td class="text-center">{{item.dealCode}}</td>
            </div>
          </template>
          <template v-slot:[`item.budget`]="{ item }">
            <div>
              <td class="text-center" v-if="item.budget">${{item.budget | thousandSeprator}}</td>
              <td class="text-center" v-else></td>
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <!-- <td>{{ props.item.name }}</td>
            <td>{{ props.item.phoneNumber }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.address }}</td>
            <td>{{ props.item.startDate}}</td>
            <td>{{ props.item.expireDate}}</td> -->
            <td v-if="item.isGroup">
              <!-- GroupEdit button -->
              <div v-if="item.groupEdit">
                <v-btn
                  color="success"
                  small
                  @click="updateXeroContact(item)"
                >Save</v-btn>
                <v-btn color="secondary" small @click="item.groupEdit=false">
                  Cancel
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  v-if="buttonShow('edit')"
                  @click="openGroupEdit(item, true)"
                  color="secondary" class="ims-action"
                >
                  <v-icon xmall>edit</v-icon>
                </v-btn>
                <v-btn v-if="buttonShow('delete')"
                  @click.stop="deleteClientGroup(item.id, item.name)"
                  color="error" class="ims-action"
                >
                  <v-icon color="white" small>delete</v-icon>
                </v-btn>
              </div>
            </td>
            <td v-else>
              <v-btn v-if="buttonShow('delete')"
                @click.stop="deleteClient(item.id)"
                color="error" class="ims-action"
              >
                <v-icon color="white" small>delete</v-icon>
              </v-btn>
              <!-- Edit button -->
              <v-btn
                v-if="buttonShow('edit')"
                @click="getClientDataToEdit(item.id)"
                color="secondary" class="ims-action"
              >
                <v-icon xmall>edit</v-icon>
              </v-btn>

              <!-- View button -->
              <v-btn
                v-if="buttonShow('view')"
                @click="getClientDataToView(item.id)"
                color="secondary" class="ims-action"
              >
                <v-icon small>remove_red_eye</v-icon>
              </v-btn>

              <!-- Create User button -->
              <v-btn
                v-if="buttonShow('updateUser')"
                @click="getClientUserDataToUpdate(item)"
                color="secondary" class="ims-action"
              >
                <v-icon small>perm_identity</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert color="error" icon="warning">
              Your search for "{{ filter }}" found no results.
            </v-alert>
          </template>
          <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
            <td :colspan="headers.length" style="border:none;padding:20px;" v-if="item.clients">
              <v-data-table
                :headers="fields"
                :items="item.clients"
                class="client-nested-table client-group-table elevation-1"
                show-expand
                :expanded.sync="expanded"
                show-select
                :single-select="false"
                v-model="selectedClients"
                @toggle-select-all="selectAllClients"
              >
                <template v-slot:[`item.data-table-expand`]="{item, expand, isExpanded}">
                  <span>
                    <v-icon @click="expand(false)" v-if="isExpanded">mdi-chevron-up</v-icon>
                    <v-icon @click="expand(true)" v-else>mdi-chevron-down</v-icon>
                  </span>
                </template>
                <template v-slot:[`item.data-table-select`]="{item}">
                  <v-checkbox
                    v-model="selectedClients"
                    label=""
                    :value="item"
                    color="grey darken-2"
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.IO`]="{ item }">
                  <div>
                    <td class="text-center">{{item.IO}}</td>
                  </div>
                </template>
                <template v-slot:[`item.dealCode`]="{ item }">
                  <div>
                    <td class="text-center">{{item.dealCode}}</td>
                  </div>
                </template>
                <template v-slot:[`item.budget`]="{ item }">
                  <div>
                    <td class="text-center" v-if="item.budget">${{item.budget | thousandSeprator}}</td>
                    <td class="text-center" v-else></td>
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <!-- <td>{{ props.item.name }}</td>
                  <td>{{ props.item.phoneNumber }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.startDate}}</td>
                  <td>{{ props.item.expireDate}}</td> -->
                  <td>
                    <v-btn v-if="buttonShow('delete')"
                      @click.stop="deleteClient(item.id)"
                      color="error" class="ims-action"
                    >
                      <v-icon color="white" small>delete</v-icon>
                    </v-btn>
                    <!-- Edit button -->
                    <v-btn
                      v-if="buttonShow('edit')"
                      @click="getClientDataToEdit(item.id)"
                      color="secondary" class="ims-action"
                    >
                      <v-icon xmall>edit</v-icon>
                    </v-btn>

                    <!-- View button -->
                    <v-btn
                      v-if="buttonShow('view')"
                      @click="getClientDataToView(item.id)"
                      color="secondary" class="ims-action"
                    >
                      <v-icon small>remove_red_eye</v-icon>
                    </v-btn>

                    <!-- Create User button -->
                    <v-btn
                      v-if="buttonShow('updateUser')"
                      @click="getClientUserDataToUpdate(item)"
                      color="secondary" class="ims-action"
                    >
                      <v-icon small>perm_identity</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
                  <!-- ********** IO Allocate Table Main (Need to copy inside clients) -->
                  <td :colspan="headers.length" class="client-expanded-cell">
                    <v-data-table
                      striped
                      bordered
                      hover
                      responsive
                      :headers="dealFields"
                      :items="item.deals"
                      class="client-nested-table client-deal-table elevation-1"
                      show-expand
                      :expanded.sync="expanded"
                      item-key="index"
                      :single-select="false"
                    >
                      <template v-slot:[`item.data-table-expand`]="{item, expand, isExpanded}">
                        <span>
                          <v-icon @click="expand(false)" v-if="isExpanded">mdi-chevron-up</v-icon>
                          <v-icon @click="expand(true)" v-else>mdi-chevron-down</v-icon>
                        </span>
                      </template>
                      <template v-slot:[`item.budget`]="{ item }">
                        <td class="text-xs-left">${{item.budget | thousandSeprator}}</td>
                      </template>
                      <template v-slot:[`item.IO`]="{ item }">
                        <td class="text-xs-left">
                          <div>{{item.IO}}</div>
                          <span v-if="item.linkedIOs">{{showLinkedIO(item.linkedIOs)}}</span>
                        </td>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <!-- <v-btn color="secondary" small @click="addAllocate(item)">
                          <v-icon>mdi-table-arrow-right</v-icon> Allocate
                        </v-btn> -->
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="secondary"
                              v-bind="attrs"
                              v-on="on"
                              small
                            >
                              Allocate
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="addAllocate(item, 'all')">
                              <v-list-item-title>All (100%)</v-list-item-title>
                            </v-list-item>
                            <v-list-item link @click="addAllocate(item, 'custom')">
                              <v-list-item-title>Custom</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
                        <td :colspan="headers.length" class="client-expanded-cell" v-if="item.campaigns">
                          <v-hover v-slot:default="{ hover }">
                            <v-card
                              color="#363636"
                              dark
                              :elevation="hover ? 12 : 2"
                              :class="{ 'mx-auto mb-2 text-center on-hover': hover, 'mx-auto mb-2 text-center': !hover}"
                              style="width:300px"
                            >
                              <v-card-subtitle>
                                <p
                                  class="pa-0 ma-0 custom-font"
                                >Used Budget: ${{getUsedBudgets(item.campaigns) | thousandSeprator}}</p>
                                <p
                                  class="pa-0 ma-0 custom-font"
                                >Remain Budgets: ${{getRemainBudgets(item.campaigns) | thousandSeprator}}</p>
                              </v-card-subtitle>
                            </v-card>
                          </v-hover>
                          <v-data-table
                            striped
                            bordered
                            hover
                            responsive
                            :headers="campaignFields"
                            :items="item.campaigns"
                            class="client-nested-table campaign-data-table client-table-small elevation-1"
                            :key="dataTableKey"
                            item-key="campaignIndex"
                          >
                            <template v-slot:[`item.name`]="{ item }">
                              <div v-if="item.edit">
                                <v-text-field
                                  class="input-field mt-3"
                                  v-model="item.name"
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="Campaign Name"
                                ></v-text-field>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-center">
                                {{item.name}}
                                &nbsp;<span v-if="item.allocatePercent">( {{ item.allocatePercent }}% )</span>
                                </td>
                              </div>
                            </template>
                            <template v-slot:[`item.partCode`]="{ item }">
                              <td class="text-center">{{item.partCode}}</td>
                            </template>
                            <template v-slot:[`item.outreach`]="{ item }">
                              <td class="text-center">{{item.outreach}}</td>
                            </template>
                            <template v-slot:[`item.period`]="{ item }">
                              <td class="text-center">{{item.period}}</td>
                            </template>
                            <template v-slot:[`item.recognizedRevenue`]="{ item }">
                              <td class="text-center" v-if="item.recognizedRevenue  !== ''">${{formatDecimal(item.recognizedRevenue) | thousandSeprator}}</td>
                              <td class="text-center" v-else></td>
                            </template>
                            <template v-slot:[`item.unRecognizedRevenue`]="{ item }">
                              <td class="text-center" v-if="item.unRecognizedRevenue !== ''">${{formatDecimal(item.unRecognizedRevenue) | thousandSeprator}}</td>
                              <td class="text-center" v-else></td>
                            </template>
                            <template v-slot:[`item.cogs`]="{ item }">
                              <td class="text-center" v-if="item.cogs  !== ''">${{item.cogs}} ({{item.cogsPercentage}}%)</td>
                              <td class="text-center" v-else></td>
                            </template>
                            <template v-slot:[`item.budget`]="{ item }">
                              <div v-if="item.edit">
                                <v-text-field
                                  type="number"
                                  class="input-field mt-3"
                                  v-model="item.budget"
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="Budget"
                                ></v-text-field>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">${{item.budget | thousandSeprator}}</td>
                              </div>
                            </template>
                            <template v-slot:[`item.outreach`]="{ item }">
                              <div v-if="item.edit">
                                <v-text-field
                                  type="number"
                                  class="input-field mt-3"
                                  v-model="item.outreach"
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="Outreach"
                                ></v-text-field>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">{{item.outreach | thousandSeprator}}</td>
                              </div>
                            </template>
                            <template v-slot:[`item.content`]="{ item }">
                              <div v-if="item.edit">
                                <v-text-field
                                  type="number"
                                  class="input-field mt-3 mb-1"
                                  v-model="item.min_content"
                                  hide-details
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="min"
                                ></v-text-field>
                                <p class="text-center ma-0">to</p>
                                <v-text-field
                                  type="number"
                                  class="input-field mb-1"
                                  v-model="item.max_content"
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="max"
                                ></v-text-field>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">{{item.min_content}} - {{item.max_content}}</td>
                              </div>
                            </template>
                            <template v-slot:[`item.engagement`]="{ item }">
                              <div v-if="item.edit">
                                <v-text-field
                                  type="number"
                                  class="input-field mt-3"
                                  v-model="item.engagement"
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="Engagement"
                                ></v-text-field>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">{{item.engagement | thousandSeprator}}</td>
                              </div>
                            </template>
                            <template v-slot:[`item.kpi_onboarded`]="{ item }">
                              <div v-if="item.edit">
                                <v-text-field
                                  type="number"
                                  class="input-field mt-3"
                                  v-model="item.kpi_onboarded"
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="KPI Onboarded"
                                ></v-text-field>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">{{item.kpi_onboarded | thousandSeprator}}</td>
                              </div>
                            </template>
                            <template v-slot:[`item.campaignType`]="{ item }">
                              <div v-if="item.edit">
                                <v-select
                                  class="input-field"
                                  v-model="item.campaignType"
                                  :items="campaignTypeDisplay"
                                  label="Product Type"
                                  dense
                                  outlined
                                ></v-select>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">{{item.campaignType}}</td>
                              </div>
                            </template>
                            <template v-slot:[`item.country`]="{ item }">
                              <div v-if="item.edit">
                                <!-- <v-text-field
                                  type="number"
                                  class="input-field mt-3"
                                  v-model="item.country"
                                  dense
                                  outlined
                                  v-on="on"
                                  placeholder="Country"
                                ></v-text-field> -->
                                <v-combobox
                                  :search-input.sync="newCountry"
                                  v-model="item.country"
                                  :items="countries"
                                  item-text="name"
                                  item-value="code"
                                  hide-selected
                                  chips
                                  label="Country"
                                  multiple
                                  dense
                                  outlined
                                >
                                  <template v-slot:selection="{ attrs, item, parent, selected }">
                                    <v-chip
                                      v-if="item === Object(item)"
                                      v-bind="attrs"
                                      :input-value="selected"
                                      label
                                      small
                                    >
                                      <span class="pr-2">
                                        {{ item.name }}
                                      </span>
                                      <v-icon
                                        small
                                        @click="parent.selectItem(item)"
                                      >
                                        $delete
                                      </v-icon>
                                    </v-chip>
                                    <v-chip
                                      v-else
                                      v-bind="attrs"
                                      :input-value="selected"
                                      label
                                      small
                                    >
                                      <span class="pr-2">
                                        {{ item }}
                                      </span>
                                      <v-icon
                                        small
                                        @click="parent.selectItem(item)"
                                      >
                                        $delete
                                      </v-icon>
                                    </v-chip>
                                  </template>
                                </v-combobox>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">
                                  <v-chip
                                    small
                                    v-for="(item, index) in item.country"
                                    :key="index"
                                    class="ma-1"
                                  >
                                    {{item.name}}
                                  </v-chip>
                                </td>
                              </div>
                            </template>
                            <template v-slot:[`item.vertical`]="{ item }">
                              <div v-if="item.edit">
                                <v-combobox
                                  v-model="item.vertical"
                                  :items="campaignVerticals"
                                  item-text="name"
                                  item-value="name"
                                  hide-selected
                                  dense
                                  outlined
                                  label="Campaign Vertical"
                                  multiple
                                >
                                  <!-- <template v-slot:no-data>
                                    <v-list-item>
                                      <span class="subheading pr-2">Press Enter to Create</span>
                                      <v-chip
                                        label
                                        small
                                      >
                                        {{ newCampaignVertical }}
                                      </v-chip>
                                    </v-list-item>
                                  </template> -->
                                  <template v-slot:selection="{ attrs, item, parent, selected }">
                                    <v-chip
                                      v-if="item === Object(item)"
                                      v-bind="attrs"
                                      :input-value="selected"
                                      label
                                      small
                                    >
                                      <span class="pr-2">
                                        {{ item.name }}
                                      </span>
                                      <v-icon
                                        small
                                        @click="parent.selectItem(item)"
                                      >
                                        $delete
                                      </v-icon>
                                    </v-chip>
                                  </template>
                                </v-combobox>
                              </div>
                              <div class="item-edit" v-else>
                                <td class="text-xs-left">
                                  <v-chip
                                    small
                                    v-for="(item, index) in item.vertical"
                                    :key="index"
                                    class="ma-1"
                                  >
                                    {{item.name}}
                                  </v-chip>
                                </td>
                              </div>
                            </template>
                            <template v-slot:[`item.assignedTo`]="{ item }">
                              <div v-if="item.assignedTo">
                                <v-chip v-for="(item, index) in item.assignedTo" :key="index" :value="item"
                                  class="ma-2"
                                  filter
                                  small
                                >
                                  <v-avatar style="margin-right:5px;">
                                    <v-icon small>account_circle</v-icon>
                                  </v-avatar>
                                  {{item.firstName + ' ' + item.lastName}}
                                </v-chip>
                              </div>
                            </template>
                            <template v-slot:[`item.assignedToAM`]="{ item }">
                              <div v-if="item.assignedToAM">
                                <v-chip v-for="(item, index) in item.assignedToAM" :key="index" :value="item"
                                  class="ma-2"
                                  filter
                                  small
                                >
                                  <v-avatar style="margin-right:5px;">
                                    <v-icon>account_circle</v-icon>
                                  </v-avatar>
                                  {{item.firstName + ' ' + item.lastName}}
                                </v-chip>
                              </div>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                              <div v-if="!item.edit">
                                <!-- Edit button -->
                                <v-btn v-if="buttonShow('edit')" small @click="item.edit=true" color="secondary" class="ims-action">
                                  <v-icon xmall>edit</v-icon>
                                </v-btn>
                                <!-- Delete button -->
                                <v-btn v-if="buttonShow('delete')" small @click="deleteCampaign(item)" color="error" class="ims-action">
                                  <v-icon color="white" small>delete</v-icon>
                                </v-btn>
                              </div>
                              <div v-if="item.edit">
                                <v-btn
                                  class="mb-2"
                                  color="success"
                                  small
                                  @click="saveCampaign(item)"
                                >Save</v-btn>
                                <v-btn color="secondary" small @click="cancelCampaignRow(item)" v-if="item.id===0">
                                  Cancel
                                </v-btn>
                                <v-btn color="secondary" small @click="item.edit=false" v-else>
                                  Cancel
                                </v-btn>
                              </div>
                            </template>
                          </v-data-table>
                        </td>
                      </template>
                    </v-data-table>
                  </td>
                  <!-- End of IO Allocate Table Main -->
                </template>
              </v-data-table>
            </td>

            <!-- ************ Place Copied Allocate Table Contents Here ************ -->
            <td :colspan="headers.length" class="client-expanded-cell" v-else>
              <v-data-table
                striped
                bordered
                hover
                responsive
                :headers="dealFields"
                :items="item.deals"
                class="client-nested-table client-deal-table elevation-1"
                show-expand
                :expanded.sync="expanded"
                item-key="index"
                :single-select="false"
              >
                <template v-slot:[`item.data-table-expand`]="{item, expand, isExpanded}">
                  <span>
                    <v-icon @click="expand(false)" v-if="isExpanded">mdi-chevron-up</v-icon>
                    <v-icon @click="expand(true)" v-else>mdi-chevron-down</v-icon>
                  </span>
                </template>
                <template v-slot:[`item.linkedIOs`]="{ item }">
                  <td class="text-xs-left">
                    <span v-if="item.linkedIOs">{{showLinkedIO(item.linkedIOs)}}</span>
                  </td>
                </template>
                <template v-slot:[`item.budget`]="{ item }">
                  <td class="text-xs-left">${{item.budget | thousandSeprator}}</td>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <!-- <v-btn color="secondary" small @click="addAllocate(item)">
                    <v-icon>mdi-table-arrow-right</v-icon> Allocate
                  </v-btn> -->
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="secondary"
                        v-bind="attrs"
                        v-on="on"
                        small
                      >
                        Allocate
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item link @click="addAllocate(item, 'custom')">
                        <v-list-item-title>New</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="addAllocate(item, 'all')">
                        <v-list-item-title>All</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
                  <td :colspan="headers.length" class="client-expanded-cell" v-if="item.campaigns">
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        color="#363636"
                        dark
                        :elevation="hover ? 12 : 2"
                        :class="{ 'mx-auto mb-2 text-center on-hover': hover, 'mx-auto mb-2 text-center': !hover}"
                        style="width:300px"
                      >
                        <v-card-subtitle>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Used Budget: ${{getUsedBudgets(item.campaigns) | thousandSeprator}}</p>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Remain Budgets: ${{getRemainBudgets(item.campaigns) | thousandSeprator}}</p>
                        </v-card-subtitle>
                      </v-card>
                    </v-hover>
                    <v-data-table
                      striped
                      bordered
                      hover
                      responsive
                      :headers="campaignFields"
                      :items="item.campaigns"
                      class="client-nested-table campaign-data-table client-table-small elevation-1"
                      :key="dataTableKey"
                      item-key="campaignIndex"
                    >
                      <template v-slot:[`item.name`]="{ item }">
                        <div v-if="item.edit">
                          <v-text-field
                            class="input-field mt-3"
                            v-model="item.name"
                            dense
                            outlined
                            v-on="on"
                            placeholder="Campaign Name"
                          ></v-text-field>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-center">{{item.name}}</td>
                        </div>
                      </template>
                      <template v-slot:[`item.partCode`]="{ item }">
                        <td class="text-center">{{item.partCode}}</td>
                      </template>
                      <template v-slot:[`item.outreach`]="{ item }">
                        <td class="text-center">{{item.outreach}}</td>
                      </template>
                      <template v-slot:[`item.period`]="{ item }">
                        <td class="text-center">{{item.period}}</td>
                      </template>
                      <template v-slot:[`item.recognizedRevenue`]="{ item }">
                        <td class="text-center" v-if="item.recognizedRevenue  !== ''">${{formatDecimal(item.recognizedRevenue) | thousandSeprator}}</td>
                        <td class="text-center" v-else></td>
                      </template>
                      <template v-slot:[`item.unRecognizedRevenue`]="{ item }">
                        <td class="text-center" v-if="item.unRecognizedRevenue !== ''">${{formatDecimal(item.unRecognizedRevenue) | thousandSeprator}}</td>
                        <td class="text-center" v-else></td>
                      </template>
                      <template v-slot:[`item.cogs`]="{ item }">
                        <td class="text-center" v-if="item.cogs  !== ''">${{item.cogs}} ({{item.cogsPercentage}}%)</td>
                        <td class="text-center" v-else></td>
                      </template>
                      <template v-slot:[`item.budget`]="{ item }">
                        <div v-if="item.edit">
                          <v-text-field
                            type="number"
                            class="input-field mt-3"
                            v-model="item.budget"
                            dense
                            outlined
                            v-on="on"
                            placeholder="Budget"
                          ></v-text-field>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">${{item.budget | thousandSeprator}}</td>
                        </div>
                      </template>
                      <template v-slot:[`item.outreach`]="{ item }">
                        <div v-if="item.edit">
                          <v-text-field
                            type="number"
                            class="input-field mt-3"
                            v-model="item.outreach"
                            dense
                            outlined
                            v-on="on"
                            placeholder="Outreach"
                          ></v-text-field>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">{{item.outreach | thousandSeprator}}</td>
                        </div>
                      </template>
                      <template v-slot:[`item.content`]="{ item }">
                        <div v-if="item.edit">
                          <v-text-field
                            type="number"
                            class="input-field mt-3 mb-1"
                            v-model="item.min_content"
                            hide-details
                            dense
                            outlined
                            v-on="on"
                            placeholder="min"
                          ></v-text-field>
                          <p class="text-center ma-0">to</p>
                          <v-text-field
                            type="number"
                            class="input-field mb-1"
                            v-model="item.max_content"
                            dense
                            outlined
                            v-on="on"
                            placeholder="max"
                          ></v-text-field>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">{{item.min_content}} - {{item.max_content}}</td>
                        </div>
                      </template>
                      <template v-slot:[`item.engagement`]="{ item }">
                        <div v-if="item.edit">
                          <v-text-field
                            type="number"
                            class="input-field mt-3"
                            v-model="item.engagement"
                            dense
                            outlined
                            v-on="on"
                            placeholder="Engagement"
                          ></v-text-field>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">{{item.engagement | thousandSeprator}}</td>
                        </div>
                      </template>
                      <template v-slot:[`item.kpi_onboarded`]="{ item }">
                        <div v-if="item.edit">
                          <v-text-field
                            type="number"
                            class="input-field mt-3"
                            v-model="item.kpi_onboarded"
                            dense
                            outlined
                            v-on="on"
                            placeholder="KPI Onboarded"
                          ></v-text-field>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">{{item.kpi_onboarded | thousandSeprator}}</td>
                        </div>
                      </template>
                      <template v-slot:[`item.campaignType`]="{ item }">
                        <div v-if="item.edit">
                          <v-select
                            class="input-field"
                            v-model="item.campaignType"
                            :items="campaignTypeDisplay"
                            label="Product Type"
                            dense
                            outlined
                          ></v-select>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">{{item.campaignType}}</td>
                        </div>
                      </template>
                      <template v-slot:[`item.country`]="{ item }">
                        <div v-if="item.edit">
                          <!-- <v-text-field
                            type="number"
                            class="input-field mt-3"
                            v-model="item.country"
                            dense
                            outlined
                            v-on="on"
                            placeholder="Country"
                          ></v-text-field> -->
                          <v-combobox
                            :search-input.sync="newCountry"
                            v-model="item.country"
                            :items="countries"
                            item-text="name"
                            item-value="code"
                            hide-selected
                            chips
                            label="Country"
                            multiple
                            dense
                            outlined
                          >
                            <template v-slot:selection="{ attrs, item, parent, selected }">
                              <v-chip
                                v-if="item === Object(item)"
                                v-bind="attrs"
                                :input-value="selected"
                                label
                                small
                              >
                                <span class="pr-2">
                                  {{ item.name }}
                                </span>
                                <v-icon
                                  small
                                  @click="parent.selectItem(item)"
                                >
                                  $delete
                                </v-icon>
                              </v-chip>
                              <v-chip
                                v-else
                                v-bind="attrs"
                                :input-value="selected"
                                label
                                small
                              >
                                <span class="pr-2">
                                  {{ item }}
                                </span>
                                <v-icon
                                  small
                                  @click="parent.selectItem(item)"
                                >
                                  $delete
                                </v-icon>
                              </v-chip>
                            </template>
                          </v-combobox>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">
                            <v-chip
                              small
                              v-for="(item, index) in item.country"
                              :key="index"
                              class="ma-1"
                            >
                              {{item.name}}
                            </v-chip>
                          </td>
                        </div>
                      </template>
                      <template v-slot:[`item.vertical`]="{ item }">
                        <div v-if="item.edit">
                          <v-combobox
                            v-model="item.vertical"
                            :items="campaignVerticals"
                            item-text="name"
                            item-value="name"
                            hide-selected
                            dense
                            outlined
                            label="Campaign Vertical"
                            multiple
                          >
                            <!-- <template v-slot:no-data>
                              <v-list-item>
                                <span class="subheading pr-2">Press Enter to Create</span>
                                <v-chip
                                  label
                                  small
                                >
                                  {{ newCampaignVertical }}
                                </v-chip>
                              </v-list-item>
                            </template> -->
                            <template v-slot:selection="{ attrs, item, parent, selected }">
                              <v-chip
                                v-if="item === Object(item)"
                                v-bind="attrs"
                                :input-value="selected"
                                label
                                small
                              >
                                <span class="pr-2">
                                  {{ item.name }}
                                </span>
                                <v-icon
                                  small
                                  @click="parent.selectItem(item)"
                                >
                                  $delete
                                </v-icon>
                              </v-chip>
                            </template>
                          </v-combobox>
                        </div>
                        <div class="item-edit" v-else>
                          <td class="text-xs-left">
                            <v-chip
                              small
                              v-for="(item, index) in item.vertical"
                              :key="index"
                              class="ma-1"
                            >
                              {{item.name}}
                            </v-chip>
                          </td>
                        </div>
                      </template>
                      <template v-slot:[`item.assignedTo`]="{ item }">
                        <div v-if="item.assignedTo">
                          <v-chip v-for="(item, index) in item.assignedTo" :key="index" :value="item"
                            class="ma-2"
                            filter
                          >
                            <v-avatar style="margin-right:5px;">
                              <v-icon>account_circle</v-icon>
                            </v-avatar>
                            {{item.firstName + ' ' + item.lastName}}
                          </v-chip>
                        </div>
                      </template>
                      <template v-slot:[`item.assignedToAM`]="{ item }">
                        <div v-if="item.assignedToAM">
                          <v-chip v-for="(item, index) in item.assignedToAM" :key="index" :value="item"
                            class="ma-2"
                            filter
                          >
                            <v-avatar style="margin-right:5px;">
                              <v-icon>account_circle</v-icon>
                            </v-avatar>
                            {{item.firstName + ' ' + item.lastName}}
                          </v-chip>
                        </div>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <div v-if="!item.edit">
                          <!-- Edit button -->
                          <v-btn v-if="buttonShow('edit')" small @click="item.edit=true" color="secondary" class="ims-action">
                            <v-icon xmall>edit</v-icon>
                          </v-btn>
                          <!-- Delete button -->
                          <v-btn v-if="buttonShow('delete')" small @click="deleteCampaign(item)" color="error" class="ims-action">
                            <v-icon color="white" small>delete</v-icon>
                          </v-btn>
                        </div>
                        <div v-if="item.edit">
                          <v-btn
                            class="mb-2"
                            color="success"
                            small
                            @click="saveCampaign(item)"
                          >Save</v-btn>
                          <v-btn color="secondary" small @click="cancelCampaignRow(item)" v-if="item.id===0">
                            Cancel
                          </v-btn>
                          <v-btn color="secondary" small @click="item.edit=false" v-else>
                            Cancel
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </td>
                </template>
              </v-data-table>
            </td>
            <!-- End of Copied IO Allocate Table Main -->
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- CreateClient modal -->
    <create-client-modal @createClient="createClient" v-model="createClientDialog" />

    <!-- EditClient modal -->
    <edit-client-modal :clientData="editClientData" @editClient="editClient" :viewMode="isViewMode" v-model="editClientDialog"/>

    <!-- UpdateClientUser modal -->
    <update-client-user-modal
    :clientLoginData="updateClientLoginData"
    :existingAccounts="existingAccounts"
    v-model="updateClientLoginModal"
    @reRenderDataTable="reRenderDataTable"/>

    <!-- CreateClient modal -->
    <view-client-modal :clientData="viewClientData" v-model="viewClientDialog"/>

    <!-- Client Group Modal -->
    <client-group-modal
    :selectedClients="selectedClients"
    @saved="savedClientGroup"
    v-model="clientGroupDialog"/>

    <!-- Custom Amount Update Modal -->
    <custom-amount-update-modal
      v-model="customAmountUpdateDialog"
      :value="customAmountUpdateDialog"
      :dealData="viewDealData"
      @addedAmount="allocateCampaign"
    />
  </div>
</template>
<script>
import moment from 'moment'
import config from '@/config'
// import { mapState } from 'vuex';
import campaignConfig from '../Campaign/config';
import campaignHelper from '../Campaign/campaignHelper';
import clientAPIs from './clientAPIs'
import xeroAPIS from '../Xero/XeroAPIs'
import campaignAPIs from '../Campaign/campaignAPIs';
import userAPIs from '../User/userAPIs';
import CreateClientModal from './CreateClientModal'
import EditClientModal from './EditClientModal'
import UpdateClientUserModal from './UpdateClientUserModal'
import ViewClientModal from './ViewClientModal'
import ClientGroupModal from './ClientGroupModal'
import CustomAmountUpdateModal from './CustomAmountUpdateModal'
import utils from '../../../utils';
import countries from '../../../../static/sources/countries';

export default {
  name: 'Client',
  components: {
    CreateClientModal,
    EditClientModal,
    UpdateClientUserModal,
    ViewClientModal,
    ClientGroupModal,
    CustomAmountUpdateModal
  },
  data() {
    return {
      countries,
      createClientDialog: false,
      editClientDialog: false,
      viewClientDialog: false,
      updateClientLoginModal: false,
      clientGroupDialog: false,
      customAmountUpdateDialog: false,
      isViewMode: false,
      editClientData: null,
      updateClientLoginData: null,
      viewClientData: null,
      viewDealData: null,
      sortBy: 'name',
      sortDesc: false,
      options: {
        groupDesc: false
      },
      fields: [
        { value: 'name', text: 'Client Name', sortable: true, groupable: false },
        { value: 'phoneNumber', text: 'Contact Number', sortable: true, groupable: false },
        { value: 'showEmail', text: 'Contact Email', sortable: true, groupable: false },
        { value: 'IO', text: 'IO Number', sortable: true, groupable: false },
        // { value: 'dealCode', text: 'Client and Campaign Code', sortable: true, groupable: false },
        { value: 'budget', text: 'Budget', sortable: true, groupable: false },
        { value: 'action', text: 'Actions', sortable: false, groupable: false }
      ],
      dealFields: [
        { value: 'name', text: 'Deal Name', sortable: true, groupable: false },
        { value: 'IO', text: 'IO Number', sortable: true, groupable: false },
        { value: 'campaignType', text: 'Product Type', sortable: true, groupable: false },
        { value: 'budget', text: 'Budget', sortable: true, groupable: false },
        { value: 'email', text: 'Email', sortable: true, groupable: false },
        // { value: 'dealCode', text: 'Client and Campaign Code', sortable: true, groupable: false },
        { value: 'quoteAcceptanceDate', text: 'Quote Acceptance Date', sortable: true, groupable: false },
        { value: 'action', text: 'Allocate Campaign', sortable: false, groupable: false }
      ],
      campaignFields: [
        { value: 'name', text: 'Campaign Name', sortable: true, groupable: false },
        { value: 'partCode', text: 'Part Code', sortable: true, groupable: false },
        { value: 'budget', text: 'Budget', sortable: true, groupable: false },
        { value: 'outreach', text: 'KPI Outreach', sortable: true, groupable: false },
        { value: 'content', text: 'KPI Content', sortable: true, groupable: false },
        { value: 'engagement', text: 'KPI Engagement', sortable: true, groupable: false },
        { value: 'kpi_onboarded', text: 'KPI Onboarded', sortable: true, groupable: false },
        // { value: 'period', text: 'Campaign Period', sortable: true, groupable: false },
        { value: 'campaignType', text: 'Product Type', sortable: true, groupable: false },
        { value: 'country', text: 'Country', sortable: true, groupable: false },
        { value: 'vertical', text: 'Vertical', sortable: true, groupable: false },
        { value: 'assignedTo', text: 'Assigned CC', sortable: true, groupable: false },
        { value: 'assignedToAM', text: 'Assigned AM', sortable: true, groupable: false },
        // { value: 'recognizedRevenue', text: 'Recognized Revenue', sortable: true, groupable: false },
        // { value: 'unRecognizedRevenue', text: 'Unrecognized Revenue', sortable: true, groupable: false },
        // { value: 'cogs', text: 'COGS', sortable: true, groupable: false },
        { value: 'action', text: 'Actions', sortable: false, groupable: false }
      ],
      campaigns: [],
      campaignType: campaignConfig.campaignType,
      campaignTypeDisplay: campaignConfig.campaignTypeDisplay,
      // countries: campaignConfig.targetAudienceDisplay.LOCATION,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'name',
        descending: false
      },
      items: [],
      selectedClients: [],
      submitting: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filter: '',
      clientGroups: [],
      xeroContacts: [],
      existingAccounts: [],
      campaignVerticals: [],
      selectedCampaignVertical: [],
      assignUsers: []
    }
  },
  computed: {
    // ...mapState({
    //   countries: state => state.campaign.countries
    // }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    },
    updatedOn: function() {
      return moment(this.lastUpdate).fromNow()
    }
  },
  watch: {
    currentPage() {
      this.paginate(this.currentPage)
    }
  },
  methods: {
    buttonShow(type) {
      const roleAllow = config['userPermissions']['client'][type]
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false
    },
    async updateItems(response) {
      this.items = []
      let displayItems = response.clients.map(element => {
        let deals = []
        let hasDeals = false
        if (typeof element.account !== 'undefined') {
          if (typeof element.account.deals !== 'undefined') {
            if (element.account.deals.length > 0) {
              hasDeals = true
            }
          }
        }
        if (hasDeals) {
          deals = element.account.deals.map((deal, index) => {
            // set campaigns
            let dealCampaigns = this.campaigns.filter(c => {
              if (((deal.dealCode && (c.dealCode && deal.dealCode === c.dealCode)) ||
              (deal.IO && (deal.IO === c.ioNumbers))) &&
              ((c.clientID && (c.clientID === element.id)))) {
                return true
              }
              return false
            })
            dealCampaigns = dealCampaigns.map((campaign, campaignIndex) => {
              return Object.assign(
                {
                  clientID: element.id,
                  companyID: element.companyID,
                  dealCode: deal.dealCode,
                  id: campaign.id,
                  campaignIndex
                },
                {
                  name: campaign.name,
                  partCode: campaign.partCode || '-',
                  ioNumbers: campaign.ioNumbers || '',
                  dealBudget: deal.budget,
                  budget: campaign.budget,
                  outreach: campaign.outreach,
                  min_content: campaign.min_content,
                  max_content: campaign.max_content,
                  kpi_onboarded: campaign.kpi_onboarded,
                  country: campaignHelper.formatCountry(this.countries, campaign.targetLocation || []),
                  vertical: this.formatCampaignVerticals(campaign),
                  engagement: campaign.engagement,
                  period: '-',
                  campaignType: this.getProductName(campaign.campaignType),
                  assignedTo: this.getDedicatedPersons(element.handledBy || [], config.userRoles.AD_STRATEGIST),
                  assignedToAM: this.getDedicatedPersons(element.handledBy || [], config.userRoles.ACCOUNT_MANAGER),
                  recognizedRevenue: campaign.revenueRecognized || campaign.revenueRecognized === 0 ? campaign.revenueRecognized : '',
                  unRecognizedRevenue: campaign.unrecognizedRevenue || campaign.unrecognizedRevenue === 0 ? campaign.unrecognizedRevenue : '',
                  cogs: campaign.cogs || '',
                  cogsPercentage: campaign.cogsPercentage || '',
                  allocatePercent: campaign.allocatePercent || '',
                  status: campaign.status,
                  edit: false
                }
              )
            })
            // dealCampaigns = dealCampaigns.sort((a, b) => a.partCode - b.partCode)
            dealCampaigns.sort(function(a, b) {
              if (a.partCode < b.partCode) { return -1; }
              if (a.partCode > b.partCode) { return 1; }
              return 0;
            })
            // get deals object
            return Object.assign(
              { clientID: element.id,
                companyID: element.companyID,
                index
              },
              {
                name: deal.name || element.name,
                contactName: element.contactName || '',
                contacts: element.contacts,
                IO: deal.IO,
                linkedIOs: deal.linkedIOs || [],
                campaignType: deal.products.map(p => this.getProductName(p.name)).join(','),
                budget: deal.budget,
                email: element.email,
                dealCode: deal.dealCode || 'N/A',
                handledBy: element.handledBy,
                quoteAcceptanceDate: deal.quoteAcceptanceDate,
                vertical: deal.vertical || [],
                country: deal.country || [],
                products: deal.products,
                campaigns: dealCampaigns
              }
            )
          })
        }
        // get client items with deals
        let {IO, dealCode, budget} = this.getDealsGroupSummary(deals)
        return Object.assign(
          { id: element.id },
          {
            name: element.name,
            contactName: element.contactName || '',
            contacts: element.contacts,
            group: element.group || '',
            phoneNumber: element.phoneNumber,
            email: element.email || '',
            showEmail: this.getClientEmails(element),
            address: element.address || '-',
            startDate: element.account && element.account.startDate ? element.account.startDate : '-',
            expireDate: element.account && element.account.expireDate ? element.account.expireDate : '-',
            deals,
            IO,
            dealCode,
            budget
          }
        )
      })
      this.items = displayItems
      this.totalRows = response.totalClients
      // this.items = await this.getCampaignSummary(this.items)
      this.items = await this.getClientGroupItems(this.items)
    },
    paginate(page = 1) {
      this.currentPage = page
      clientAPIs
        .paginate(page, this.perPage, this.filter)
        .then(response => {
          this.updateItems(response)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    createClient(clientData) {
      // Update table locally without reloading
      this.selectedClients = []
      this.items.push(clientData)
    },
    deleteClient(clientID) {
      // Display confirmation box
      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the client?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return clientAPIs
            .deleteClient(clientID)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.items = this.items.filter(client => {
            // check and remove in client group or client lists after deleted
            if (client.isGroup && client.clients) {
              client.clients = client.clients.filter(cl => cl.id !== clientID)
              if (client.clients.length) {
                return true
              } else return false
            } else {
              return client.id !== clientID
            }
          })

          // Show success message
          this.$swal({
            title: 'Deleted',
            text: 'The client has been deleted successfully',
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    getClientDataToEdit(clientID) {
      clientAPIs
        .getClient(clientID)
        .then(response => {
          this.editClientData = response
          this.editClientDialog = true
          this.isViewMode = false
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    getClientDataToView(clientID) {
      this.isViewMode = false
      clientAPIs
        .getClient(clientID)
        .then(response => {
          // this.viewClientData = Object.assign({}, response)
          // this.viewClientDialog = true
          this.editClientData = Object.assign({}, response)
          this.editClientDialog = true
          this.isViewMode = true
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    getClientUserDataToUpdate(item) {
      let clientID = item.id
      clientAPIs
        .getClientUser(clientID)
        .then(response => {
          response = Array.isArray(response) ? response : []
          let updateData = utils.func.refreshJSON(response.find(r => r.email === item.email))
          // if no match accounts, set default account
          if (!updateData && response.length > 0) {
            let responseOne = response[0]
            updateData = Object.assign({}, {
              firstName: responseOne.firstName,
              lastName: responseOne.lastName
            })
          }
          // Inject client id into the response
          updateData.clientID = clientID
          updateData.contacts = item.contacts || []
          // Check email is already updated and email is available from User response.
          if (!updateData.email) {
            // Check current client has an email or not. if yes inject into response to get email on the UpdatedUserModel form email field.
            if (item.email) {
              updateData.email = item.email
            }
          }
          this.updateClientLoginData = updateData
          // this.existingAccounts = response.filter(r => r.email !== item.email)
          this.existingAccounts = Object.assign([], response)
          this.existingAccounts = this.existingAccounts.map(e => {
            e.password = ''
            e.show1 = false
            return e
          })
          this.updateClientLoginModal = true
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    editClient(clientData) {
      // Update the edited content to user
      var selectedIndex = -1

      this.items.forEach(function(client, index) {
        if (client.id === clientData.id) {
          selectedIndex = index
          return
        }
      })

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, clientData)
      }

      // Do anything like highlighting the edited item
      this.selectedClients = []
      console.log('Client edited')
      this.paginate(1)
    },
    reRenderDataTable() {
      this.paginate(this.currentPage)
    },
    selectAllClients($event) {
      if (!$event.value) {
        this.selectedClients = [];
        return;
      }
      this.selectedClients = Object.assign([], this.items);
    },
    openClientGroupModal() {
      this.clientGroupDialog = true
    },
    savedClientGroup() {
      this.selectedClients = []
      this.reRenderDataTable()
    },
    openGroupEdit(item, status = false) {
      let groupIndex = this.items.findIndex(i => i.id === item.id)
      this.items[groupIndex].groupEdit = status
      this.items = utils.func.refreshJSON(this.items)
      this.selectedClients = []
    },
    updateXeroContact(item) {
      // Update Group
      xeroAPIS
        .updateXeroContact(item.id, {name: item.name})
        .then(response => {
          item.groupEdit = false
          this.selectedClients = []
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
          // Show error message
          this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
        })
    },
    deleteClientGroup(groupID, groupName) {
      // Display confirmation box
      this.$swal({
        title: 'Deleting',
        text: `Are you sure you want to delete this group (${groupName})?`,
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return clientAPIs
            .deleteClientGroup(groupID)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.clientGroups = this.clientGroups.filter(group => group.id !== groupID)
          this.reRenderDataTable()

          // Show success message
          this.$swal({
            title: 'Deleted',
            text: 'The group has been deleted successfully',
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    async addAllocate(item, type) {
      this.expanded = true
      let updateData = {
        deal: item,
        products: [],
        type
      }
      if (type === 'all') {
        updateData.products = item.products
        this.allocateCampaign(updateData)
      } else {
        updateData.products.push({type: 'custom'})
        this.viewDealData = updateData
        this.customAmountUpdateDialog = true
      }
    },
    async allocateCampaign(obj) {
      let budget = 0
      let item = obj.deal
      let products = obj.products
      let type = obj.type
      if (type === 'all') {
        budget = item.budget || 0
      } else {
        let budgetPercentAmt = Number(((Number(item.budget) * Number(obj.amount)) / 100).toFixed(2))
        budget = budgetPercentAmt
      }
      for (let product of products) {
        let partCode = ''
        if (item.dealCode && item.dealCode !== 'N/A') {
          partCode = await this.getPartCodebyDeal(item.dealCode, item.campaigns)
        }
        // let product = item.products.length > 0 ? item.products[0] : null
        let outreach = 0
        let minContent = 0
        let maxContent = 0
        let kpiOnboarded = 0
        let engagement = 0
        let campaignType = this.campaignType.NO_PREFERENCE
        if (type === 'all' && product !== null) {
          if (product.name.toLowerCase() === this.campaignType.AMPLIFY.toLowerCase()) {
            outreach = product.views || 0
          } else {
            outreach = product.totalOutReach || 0
          }
          minContent = product.minContent || 0
          maxContent = product.maxContent || 0
          kpiOnboarded = product.kpiOnboarded || 0
          engagement = product.totalEngagement || 0
        }
        if (item.campaignType !== null) {
          let type = this.campaignTypeDisplay.find(c => c.value.toLowerCase() === item.campaignType.toLowerCase())
          if (type) {
            campaignType = type.value
          }
        }
        let countryLists = this.countries.filter(c => item.country.includes(c.code))
        item.campaigns.push(
          Object.assign({
            clientID: item.clientID,
            companyID: item.companyID,
            dealCode: item.dealCode,
            id: 0,
            campaignIndex: item.campaigns.length,
            country: countryLists || [],
            vertical: item.vertical || []
          },
            {
              name: item.name || '',
              partCode,
              ioNumbers: item.IO,
              budget,
              outreach,
              min_content: minContent,
              max_content: maxContent,
              kpi_onboarded: kpiOnboarded,
              engagement,
              assignedTo: this.getDedicatedPersons(item.handledBy || [], config.userRoles.AD_STRATEGIST),
              assignedToAM: this.getDedicatedPersons(item.handledBy || [], config.userRoles.ACCOUNT_MANAGER),
              period: '-',
              campaignType,
              allocateType: type,
              allocatePercent: obj.amount,
              recognizedRevenue: '',
              unRecognizedRevenue: '',
              cogs: '',
              edit: true
            })
        )
      }
    },
    async saveCampaign(item) {
      console.log('save campaign', item)
      let checkstatus = this.checkBudget(this.getRootCampaigns(item))
      if (item.campaignType === campaignConfig.campaignType.NO_PREFERENCE || item.campaignType === undefined) {
        return this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Product Type'
        });
      } else if (!item.country || !item.country.length) {
        return this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Country'
        });
      } else if (item.vertical.length === 0) {
        return this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Campaign Vertical.'
        });
      }
      if (!checkstatus) {
        this.$swal({
          title: 'Not Enough Budget.',
          icon: 'warning',
          text: `The current budget for this campaign is exceeded the limited. Please check again`,
          confirmButtonText: 'Continue',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            this.doSaveCampaign(item)
          }
        })
      } else {
        this.doSaveCampaign(item)
      }
    },
    doSaveCampaign(item) {
      let campaign = this.buildCampaignFormData(item)
      let formData = new FormData();
      formData.append('campaign', JSON.stringify(campaign));
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          // Update submitting status
          this.submitting = true;
          // Submit request to create campaign
          campaignAPIs
            .createCampaignByAllocate(formData)
            .then(response => {
              item.edit = false
              let alertText = ''
              this.updateClient(item)
              if (item.id === 0) {
                item.id = response.id
                alertText = 'You can set up the campaign timeline now or stay here and continue later.'
                // Let users choose whether to continue to the campaign timeline.
                this.$swal({
                  title: 'Campaign allocated',
                  text: alertText,
                  type: 'success',
                  confirmButtonText: 'Go to Campaign Timeline',
                  showCancelButton: true,
                  cancelButtonText: 'Stay here',
                  allowOutsideClick: false
                }).then(result => {
                  if (result.value) {
                    this.$router.push({
                      path: '/campaigns/timeline',
                      query: {
                        campaignID: item.id
                      }
                    })
                  }
                })
              } else {
                item.partCode = response.partCode || '-'
                alertText = 'Campaign Updated'
                // Show success message
                this.$swal({
                  text: alertText,
                  type: 'success'
                });
              }
              // Update submitting status
              this.submitting = false;
            })
            .catch(error => {
              // Update submitting status
              this.submitting = false;
              // Request failed.
              if (error.response.status === 400) {
                this.$swal({
                  text: 'Campaign name already exists. Please change campaign name.',
                  type: 'error'
                });
              }
            });
        }
      });
    },
    deleteCampaign(item) {
      // Display confirmation box
      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the campaign?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return campaignAPIs
            .deleteCampaign(item.id)
            .then(response => {
              return response;
            })
            .catch(error => {
              // Request failed.
              console.log('error', error);

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.cancelCampaignRow(item)
          // Show success message
          this.$swal({
            title: 'Deleted',
            text: 'The campaign has been deleted successfully',
            type: 'success'
          });
        } else {
          // Do nothing for now
        }
      });
    },
    buildCampaignFormData(item) {
      if (item.country) {
        item.country = item.country.map(v => {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            }
            // this.countries.push(v)
          }
          return v
        })
      }
      let campaignCode = item.dealCode
      if (item.partCode !== '-') {
        campaignCode = `${campaignCode}-${item.partCode}`
      }
      let data = Object.assign({}, {
        id: item.id,
        clientID: item.clientID,
        companyID: item.companyID,
        dealCode: item.dealCode,
        name: item.name,
        campaignCode,
        partCode: item.partCode !== '-' ? item.partCode : null,
        ioNumbers: item.ioNumbers,
        budget: item.budget,
        outreach: item.outreach,
        min_content: item.min_content,
        max_content: item.max_content,
        kpi_onboarded: item.kpi_onboarded,
        targetLocation: item.country,
        vertical: item.vertical,
        engagement: item.engagement,
        campaignType: item.campaignType,
        allocateType: item.allocateType,
        allocatePercent: item.allocatePercent
      });
      // for new item
      if (data.id === 0) {
        data.assignedTo = item.assignedTo.map(a => a.id)
        if (item.assignedToAM) {
          item.assignedToAM.map(a => {
            data.assignedTo.push(a.id)
          })
        }
        data.goal = [];
        data.angles = [campaignHelper.getDefaultAngle()];
        data.influencer_ideal = [];
        data.influencer_unwanted = [];
        data.targetAge = ['25 - 34']
      }
      return data
    },
    cancelCampaignRow(item) {
      let campaigns = this.getRootCampaigns(item)
      let index = campaigns.findIndex(c => c.id === item.id)
      campaigns.splice(index, 1)
      campaigns = campaigns.map((c, index) => {
        c.campaignIndex = index
        return c
      })
      return true
    },
    // Nyein - hide revenue, cogs calculation as it is changed to come from campaigns table
    // async getCampaignSummary(items) {
    //   for (let item of items) {
    //     for (let deal of item.deals) {
    //       for (let campaign of deal.campaigns) {
    //         if (campaign.status && campaign.status === config.campaignStatus.ONGOING) { // In future, Campaign status could be change
    //           try {
    //             let response = await campaignAPIs.generateCampaignReport(campaign.id, null, false)
    //             let data = response.data
    //             let responseCampaignData = Object.assign({}, data.campaign_details);
    //             let summary = data.summary
    //             let posts = Object.assign([], data.posts)
    //             let liveDates = []
    //             campaign.cogs = 0
    //             campaign.cogsPercentage = 0
    //             for (let element of posts) {
    //               if (element.reportGroup) {
    //                 let reports = element.reports || []
    //                 for (let elementOne of reports) {
    //                   // this.totalCounts.contents += 1
    //                   if (elementOne.amountLocked !== true) {
    //                     campaign.cogs += Number(elementOne.amount)
    //                   }
    //                   if (elementOne.live_date !== '' && elementOne.live_date !== null) {
    //                     if (elementOne.live_date.includes('/')) {
    //                       elementOne.live_date = utils.func.parseDate(elementOne.live_date)
    //                     }
    //                     liveDates.push(elementOne.live_date)
    //                   }
    //                 }
    //               } else {
    //                 // this.totalCounts.contents += 1
    //                 if (element.amountLocked !== true) {
    //                   campaign.cogs += Number(element.amount)
    //                 }
    //                 if (element.live_date !== '' && element.live_date !== null) {
    //                   if (element.live_date.includes('/')) {
    //                     element.live_date = utils.func.parseDate(element.live_date)
    //                   }
    //                   liveDates.push(element.live_date)
    //                 }
    //               }
    //             }
    //             let cogsBudget = Math.floor(campaign.budget * 0.3);
    //             campaign.cogsPercentage = campaign.cogs > 0 ? ((campaign.cogs / cogsBudget) * 100).toFixed(2) : 0
    //             // calculate campaign periods
    //             let orderedDates = liveDates.sort(function(a, b) { return new Date(a) - new Date(b) })
    //             let minLiveDate = orderedDates.length > 0 ? moment(orderedDates[0]).format('DD/MM/YYYY') : ''
    //             let maxLiveDate = orderedDates.length > 0 ? moment(orderedDates[orderedDates.length - 1]).format('DD/MM/YYYY') : ''
    //             campaign.period = `${minLiveDate} - ${maxLiveDate}`
    //             // calculate revunue
    //             if (this.switchRevenue(responseCampaignData.revenueCalculation) === 'content') {
    //               campaign.recognizedRevenue = summary.revenueByContents ? Number(summary.revenueByContents) : 0
    //               campaign.unRecognizedRevenue = campaign.budget ? (campaign.budget - summary.revenueByContents) : 0
    //             } else if (this.switchRevenue(responseCampaignData.revenueCalculation) === 'engagement') {
    //               campaign.recognizedRevenue = summary.revenue ? Number(summary.revenue) : 0
    //               campaign.unRecognizedRevenue = campaign.budget ? (campaign.budget - summary.revenue) : 0
    //             }
    //           } catch (error) {
    //             console.log(error)
    //           }
    //         }
    //       }
    //     }
    //   }
    //   return items
    // },
    switchRevenue(revenueCalculation) {
      if (revenueCalculation !== undefined) {
        if (revenueCalculation === 'engagement') {
          return 'engagement'
        } else {
          return 'content'
        }
      } else {
        return 'engagement'
      }
    },
    async getClientGroupItems(items) {
      // get grouped clients with no group client lists
      await this.fetchXeroContact()
      let groups = this.xeroContacts
      groups = groups.map(group => {
        let groupItems = items.filter(c => c.group && c.group.id === group.id)
        let {IO, dealCode, budget} = this.getDealsGroupSummary(groupItems)
        group = Object.assign(group, {
          name: group.Name,
          phoneNumber: '',
          showEmail: this.getGroupedClientEmails(groupItems),
          address: '',
          startDate: '',
          expireDate: '',
          clients: groupItems,
          IO,
          dealCode,
          budget,
          isGroup: true
        })
        return group
      })
      // filter groups which have clients
      groups = groups.filter(g => g.clients && g.clients.length > 0)
      let noGroupItems = items.filter(c => !c.group)
      groups.push(...noGroupItems)
      return groups
    },
    async getClientGroups() {
      try {
        const resp = await clientAPIs.getClientGroups();
        if (resp.success) {
          this.clientGroups = resp.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getRootCampaigns(item) {
      let {groupIndex, clientIndex, dealIndex, isGroup} = this.getCampaignRootIndexes(item)
      let campaigns = []
      if (isGroup) {
        campaigns = this.items[groupIndex].clients[clientIndex].deals[dealIndex].campaigns
      } else {
        // for ungrouped items
        clientIndex = this.items.findIndex(i => i.id === item.clientID)
        dealIndex = this.items[clientIndex].deals.findIndex(d => d.dealCode === item.dealCode || d.IO === item.ioNumbers)
        campaigns = this.items[clientIndex].deals[dealIndex].campaigns
      }
      return campaigns
    },
    getCampaignRootIndexes(item) {
      let groupIndex = 0
      let clientIndex = 0
      let dealIndex = 0
      let isGroup = false
      this.items.map((loopItem, mainIndex) => {
      // for grouped items
        if (loopItem.isGroup) {
          loopItem.clients.map((client, index) => {
            if (client.id === item.clientID) {
              clientIndex = index
              groupIndex = mainIndex
              dealIndex = client.deals.findIndex(d => d.dealCode === item.dealCode || d.IO === item.ioNumbers)
              isGroup = true
            }
          })
        }
      })
      return Object.assign({}, {
        groupIndex,
        clientIndex,
        dealIndex,
        isGroup
      })
    },
    getUsedBudgets(campaigns) {
      let amount = 0
      campaigns.map(c => {
        if (c.budget) {
          amount += Number(c.budget)
        }
      })
      return (amount).toFixed(2)
    },
    getRemainBudgets(campaigns) {
      let usedAmount = this.getUsedBudgets(campaigns)
      let totalAmount = 0
      let remainAmount = 0
      if (campaigns.length > 0) {
        totalAmount = campaigns.length > 0 ? campaigns[0].dealBudget : 0
      }
      if (totalAmount > 0) {
        remainAmount = totalAmount - usedAmount
      }
      return (remainAmount).toFixed(2)
    },
    checkBudget(campaigns) {
      let remainBudgets = this.getRemainBudgets(campaigns)
      if (remainBudgets < 0) {
        return false
      }
      return true
    },
    async getPartCodebyDeal(dealCode, campaigns) {
      try {
        let response = await campaignAPIs.getDealCampaignCount(dealCode)
        let count = response.count
        let addCampaignCount = campaigns.filter(c => c.edit === true).length
        return utils.func.numToAlphabet((addCampaignCount + count) + 1)
      } catch (error) {
        console.log(error)
      }
      return ''
    },
    getDealsGroupSummary(deals) {
      let {IO, dealCode, budget} = ''
      if (deals.length > 0) {
        IO = [...new Set(deals.map(d => (d.IO ? d.IO.trim() : '')))]
        IO = IO.filter(val => (val !== undefined && val !== null && val !== '')).join(', ')
        dealCode = deals.filter(d => d.dealCode !== 'N/A').map(m => m.dealCode).join(', ')
        budget = deals.map(d => parseInt(d.budget || 0)).reduce((a, b) => a + b, 0)
      }
      return Object.assign({}, {
        IO,
        dealCode,
        budget
      })
    },
    async fetchXeroContact() {
      try {
        const resp = await xeroAPIS.getXeroContacts();
        const respData = resp.data;
        const data = respData.data;
        this.xeroContacts = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getAllCampaigns() {
      // get all campaigns
      let response = await campaignAPIs.getAllCampaignsNoStatus()
      if (response) {
        this.campaigns = response
      }
    },
    getGroupedClientEmails(clients) {
      let emails = new Set()
      clients.map(contact => {
        emails.add(contact.showEmail)
      })
      return [...emails].join(', ')
    },
    getClientEmails(client) {
      let emails = new Set()
      if (client.email !== '') {
        emails.add(client.email)
      }
      if (client.contacts !== undefined) {
        client.contacts.map(contact => {
          if (contact.email !== '') {
            emails.add(contact.email)
          }
        })
      }
      return [...emails].join(', ')
    },
    getDefaultContact(clientID, name = '', email = '') {
      return {
        clientID,
        name,
        email
      }
    },
    formatDecimal(value) {
      return parseFloat(value).toFixed(2)
    },
    getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut'
      }
      return itemName
    },
    async getCampaignVerticals() {
      let responsevertical = await campaignAPIs.getAllCampaignVerticals(false)
      this.campaignVerticals = [];
      this.campaignVerticals = responsevertical.data;
    },
    getCountryDisplayValueFromSelect: function(value) {
      if (typeof value === 'string') return value
      var selectedOption = this.countries.filter(option => {
        return value.includes(option.code)
      });
      return selectedOption ? selectedOption.map(o => o.name).join(', ') : '-';
    },
    formatCampaignVerticals(campaign) {
      let selectedCampaignVertical = []
      if (campaign.vertical) {
        this.campaignVerticals.map(item => {
          campaign.vertical.map(vertical => {
            if (item.id === vertical.id) {
              selectedCampaignVertical.push(item)
            }
          })
        })
      }
      return selectedCampaignVertical
    },
    async getAssignUsers() {
      // Get all CO user by role
      let resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (resp) this.CO = resp.users;
      // Get all AM user by role
      resp = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      if (resp) this.AM = resp.users
      this.assignUsers = Object.assign([], [...this.CO, ...this.AM])
    },
    getDedicatedPersons(handledBy, role = null) {
      let dedicatedData = []
      if (handledBy) {
        this.assignUsers.map(item => {
          handledBy.map(userId => {
            if (item.id === userId) {
              // this.orgHandledBy.push(item)
              if (role) {
                if (role === item.role) dedicatedData.push(item)
              } else dedicatedData.push(item)
            }
          })
        })
      }
      return dedicatedData
    },
    showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return ''
      IOs = IOs.map(i => {
        if (!i.includes('IO-')) {
          i = `IO-${i}`
        }
        return i
      })
      return IOs.join(', ')
    },
    async updateClient(item) {
      let clientData = await clientAPIs.getClient(item.clientID)
      if (item.ioNumbers) {
        if (clientData.account) {
          if (clientData.account.deals) {
            clientData.account.deals = clientData.account.deals.map(d => {
              d.allocatePercent = item.allocatePercent
              d.allocateType = item.allocateType
              return d
            })
          }
        }
      }
      let formData = new FormData()
      formData.append('client', JSON.stringify(clientData))
      await clientAPIs.updateClient({ clientID: item.clientID, clientInfoFormData: formData })
      return true
    }
  },
  async created() {
    this.campaignTypeDisplay = this.campaignTypeDisplay.filter(c => c.value !== this.campaignType.NO_PREFERENCE)
    await this.getAllCampaigns()
    await this.getCampaignVerticals()
    // await this.$store.dispatch('campaign/getCountries')
    await this.getAssignUsers()
    this.paginate(1)
  }
}
</script>

<style lang="scss" scoped>
.ims-action {
  margin: 6px 1px !important;
  min-width: 35px !important;
  padding: 0px !important;
}
.campaign-data-table tbody td {
  padding: 5px!important;
}
.campaign-data-table tbody td .input-field {
  font-size:13px;
}
.item-edit {
  min-width: 75px;
  min-height: 75px;
  padding-top: 22px;
  padding-left: 5px;
}

.client-expanded-cell {
  background: #f6f6f6 !important;
  border: none !important;
  padding: 16px !important;
}

.client-nested-table {
  background: #ffffff !important;
  border: 1px solid #dedede;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.08) !important;
}

.client-nested-table::v-deep .v-data-table__wrapper,
.client-nested-table::v-deep table {
  background: #ffffff !important;
}

.client-nested-table::v-deep thead tr th {
  background: #f4f4f4 !important;
}

.client-nested-table::v-deep tbody tr {
  background: #ffffff !important;
}

.client-nested-table::v-deep tbody tr:hover {
  background: #f7f7f7 !important;
}

.client-nested-table::v-deep tbody tr.v-data-table__expanded__content,
.client-nested-table::v-deep tbody tr.v-data-table__expanded__content:hover {
  background: #f6f6f6 !important;
  box-shadow: none !important;
}

.client-nested-table::v-deep tbody tr.v-data-table__expanded__content > td {
  background: #f6f6f6 !important;
  box-shadow: none !important;
}
</style>
<style>
  .client-table-small tbody td.text-start,
  .client-table-small tbody td.text-xs-left,
  .client-table-small tbody td.text-center {
    font-size: 12px!important;
    padding: 0!important;
    text-align: center!important;
  }
</style>



// WEBPACK FOOTER //
// index.vue?a339c7fc